import {useState} from "react";
import PropTypes from "prop-types";
import UTILS from "../../utils";

const FieldFileInput = ({
                            id,
                            multiple,
                            field,
                            form: {touched, errors, setFieldValue,}
                        }) => {
    const [base64Image, _setBase64Image] = useState('');

    const handleChange = async (file) => {
        const base64 = await UTILS.files.convertToBase64(file);
        setFieldValue(field.name, {file, base64});
    }

    const removeImage = (e) => {
        e.preventDefault();

        _setBase64Image('')
        setFieldValue(field.name, "")
    }

    const {value, onChange, ...rest} = field;

    return (
        <div className={"mb-8"}>
            <div className="field fieldFileInput grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-2">

                <label htmlFor={id} className={'fileInput h-24 w-full p-4 bg-white shadow rounded'}>
                    <input
                        type={'file'}
                        multiple={!!multiple}
                        name={field.name}
                        id={id}
                        onChange={(e) => handleChange(e.target.files[0])}
                        {...rest}
                    />
                    <img src={value.base64} className={"mx-auto"} alt=""/>
                    <span
                        onClick={removeImage}
                        className={`icon ${!base64Image ? 'icon-camera' : 'icon-x'} text-xl bg-gray-300  rounded-full h-8 w-8 flex justify-center items-center`}></span>
                </label>
                <p className={`py-2 px-4 w-full break-all col-span-2 max-h-lg shadow rounded bg-white text-slate-${field.value ? '600' : '300'}`}>{value?.file?.name || 'Photograph'}</p>
            </div>
            {touched[field.name] &&
                <p className="text-red-500 text-xs italic">{errors[field.name]}</p>
            }

        </div>
    )
}

export default FieldFileInput

FieldFileInput.propTypes = {
    id: PropTypes.string,
    placeholder: PropTypes.string,
    multiple: PropTypes.bool,
    field: PropTypes.object,
    form: PropTypes.object,
}

